import Vue from 'vue'
import VueHead from 'vue-head'
import App from './App.vue'

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js